import PropTypes from "prop-types";
import * as React from "react";
import {
  finalizeShopRouteInput,
  normalizeShopRouteInput,
} from "../../domain/shopRoute";
import { TextInput, Typography } from "../../themeV2";
import styles from "./AddShopDialog.module.css";
import { routeProblem } from "../../../shared/shops/route.js";
import { ACTION } from "./addShopReducer";

const getRouteError = (route, serverError) =>
  serverError ||
  (route ? routeProblem(finalizeShopRouteInput(route)) : null) ||
  undefined;

function ShopDetailsSection({ shopName, shopRoute, routeError, dispatch }) {
  const routeErrorMessage = getRouteError(shopRoute, routeError);
  const routeDescription =
    shopRoute && !routeErrorMessage
      ? `streamily.com/${finalizeShopRouteInput(shopRoute)}`
      : undefined;
  const setRoute = (value) =>
    dispatch({ type: ACTION.SET_FIELD, field: "shopRoute", value });

  return (
    <section className={styles.section}>
      <Typography variant="title-md" as="h3">
        Shop details
      </Typography>

      <TextInput
        autoFocus
        label="Shop Name"
        required
        value={shopName}
        maxLength={100}
        onChange={(e) =>
          dispatch({
            type: ACTION.SET_FIELD,
            field: "shopName",
            value: e.target.value,
          })
        }
      />

      <TextInput
        label="Shop Route"
        required
        value={shopRoute}
        error={routeErrorMessage}
        description={routeDescription}
        onChange={(e) => setRoute(normalizeShopRouteInput(e.target.value))}
        onBlur={(e) => setRoute(finalizeShopRouteInput(e.target.value))}
      />
    </section>
  );
}

ShopDetailsSection.propTypes = {
  shopName: PropTypes.string.isRequired,
  shopRoute: PropTypes.string.isRequired,
  routeError: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

export default React.memo(ShopDetailsSection);
